'use client';

import { CategoryDrawer } from '@ui/sections/categories/CategoryDrawer';
import { CategoryDrawerTrigger } from '@ui/sections/categories/CategoryDrawerTrigger';
import type { DisplayCategory } from '@ui/sections/categories/CategorySection';

interface CategoryDrawerControllerProps {
  categories: DisplayCategory[];
  seeMoreText: string;
  drawerHeadingText: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Simple client component that renders drawer trigger and drawer
 * State management is handled by parent component
 * This component doesn't use useSearchParams, so it's SSG-safe
 */
function CategoryDrawerController({
  categories,
  seeMoreText,
  drawerHeadingText,
  isOpen,
  onOpenChange
}: CategoryDrawerControllerProps) {
  return (
    <>
      <CategoryDrawerTrigger seeMoreText={seeMoreText} onOpenDrawer={() => onOpenChange(true)} />
      <CategoryDrawer
        categories={categories}
        drawerHeadingText={drawerHeadingText}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      />
    </>
  );
}

export { CategoryDrawerController };
